// At most `most` pieces of work at once; the rest wait their turn, first come first served.
export function limiter(most: number) {
  let running = 0
  const waiting: (() => void)[] = []
  return async function <T>(work: () => Promise<T>): Promise<T> {
    if (running < most) running++
    else await new Promise<void>((go) => waiting.push(go))
    try {
      return await work()
    } finally {
      // The place is handed straight to whoever waited longest, or given up.
      const next = waiting.shift()
      if (next) next()
      else running--
    }
  }
}
